<template>
  <div
    v-if="showLoadingState < 2"
    key="loading state"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billing sales data"
  >
    <blockquote v-if="puntosDeVenta.length === 0" class="quote quote-billing-primary quote-first">
      <p>
        <span>
          Aún no hay puntos de venta configurados.
        </span>
      </p>
    </blockquote>

    <AtomButtonSecondary
      :button-secondary="buttonSecondary.create"
      @createData="createData"
    />

    <div
      v-if="puntosDeVenta.length"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            Nombre
          </th>
          <th class="text-align-center">
            Comprobante
          </th>
          <th class="text-align-center">
            Moneda
          </th>
          <th class="text-align-center">
            Editar
          </th>
          <th class="text-align-center">
            Activo
          </th>
        </tr>
        <tr
          v-for="punto in puntosDeVenta"
          :key="punto.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ punto.nombre }}
          </td>
          <td class="text-align-center">
            {{ getComprobanteNombre(punto.comprobante_tipo) }}
          </td>
          <td class="text-align-center">
            {{ getDivisaIsoCode(punto.divisa.id_divisa) }}
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="punto.id"
              @editData="editData"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="punto.activo"
              :disabled="requests.updatePuntoVentaEstado.isRequested"
              :element-id="punto.id"
              method="updatePuntoVentaEstado"
              name="activo"
              :show-loading="requests.updatePuntoVentaEstado.isRequested &&
                requests.updatePuntoVentaEstado.itemLoading === punto.id"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updatePuntoVentaEstado="updatePuntoVentaEstado"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>

  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionBillingSalesData',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',

      buttonIconRounded: {
        edit: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'editData',
          tooltip: 'Editar Punto',
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-billing-secondary a-button-side',
          component: '',
          icon: 'fas fa-plus margin-right-xsmall',
          method: 'createData',
          text: 'Crear Punto',
          type: 'button'
        }
      },

      comprobantes: [
        {
          id: 1,
          nombre: 'Recibo'
        },
        {
          id: 2,
          nombre: 'Factura 0%'
        },
        {
          id: 3,
          nombre: 'Factura 21%'
        }
      ],

      divisas: [],

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      puntosDeVenta: {},

      requests: {
        updatePuntoVentaEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: 0
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readDivisas()
    this.readPuntosVenta()
  },

  methods: {
    createData () {
      return this.$router.push(`/gestion/puntos-de-venta/crear-punto`)
    },

    getComprobanteNombre (comprobanteId) {
      return this.comprobantes.find(comprobante => comprobante.id === comprobanteId).nombre
    },

    getDivisaIsoCode (divisaId) {
      return this.divisas.find(divisa => divisa.id_divisa === divisaId).iso_code
    },

    editData (puntoId) {
      this.$router.push(`/gestion/puntos-de-venta/${puntoId}/editar-punto`)
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    readPuntosVenta () {
      this.$services.read('puntoVenta', 'readPuntosVenta', {}, [this.academiaId, 0])
        .then(response => {
          this.puntosDeVenta = response.data
          this.pagination.currentQuantity = this.puntosDeVenta.length
          this.pagination.totalQuantity = this.puntosDeVenta.length
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
        })
    },

    updatePuntoVentaEstado (element) {
      if (!this.requests.updatePuntoVentaEstado.isRequested) {
        this.requests.updatePuntoVentaEstado.isRequested = true
        this.requests.updatePuntoVentaEstado.itemLoading = element.id
        this.$services.update('puntoVenta', 'updatePuntoVentaEstado', {}, [this.academiaId, element.id, element.state])
          .then(response => {
            this.readPuntosVenta()
            this.$alerts.pushAlertNotTranslated(response.data.activo ? 'El punto de venta fue activado exitosamente.' : 'El punto de venta fue desactivado exitosamente.')
            this.requests.updatePuntoVentaEstado.isRequested = false
          })
          .catch(error => {
            console.log(error)
            if (error.response.data.error.message === 'No se puede desactivar el punto venta. Una gestion activa lo utiliza') {
              this.$modal.showModal('MoleculeEditionBillingSalesDataModalActionDisabled')
              this.puntosDeVenta.find(punto => punto.id === element.id).activo = true
            } else {
              this.$alerts.pushAlertNotTranslated('Un error ha ocurrido. Vuelve a intentarlo en un momento.', 'a-alert-danger')
            }
            this.requests.updatePuntoVentaEstado.isRequested = false
          })
      }
    }
  }
}
</script>
